<template>
	<div class="detail-page">
		<div class="detail-page__header">
			<span> 公司简介 </span>
		</div>
		<div class="detail-page__content" v-html="detail.content"></div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState('YQGK', ['detail']),
	},
	created() {
		this.fetchDetailByType(2)
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('YQGK', ['fetchDetailByType']),
	},
	components: {},
}
</script>

<style lang="scss"></style>
